import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

export const FirebaseConfig = {
    apiKey: "AIzaSyAOcX9gKyvu-2EAy8J0x1mQOIvjc3EPMQU",
    authDomain: "soha-wegen-16b18.firebaseapp.com",
    databaseURL: "https://soha-wegen-16b18.firebaseio.com",
    projectId: "soha-wegen-16b18",
    storageBucket: "soha-wegen-16b18.firebasestorage.app",
    messagingSenderId: "74362172562",
    appId: "1:74362172562:web:3e53f112e59fe88cd5a24b"
};

const firebaseApp = initializeApp(FirebaseConfig);
export const db = getDatabase(firebaseApp);